import { createLanguageLoader } from 'common-react/src/hooks/useLoadLanguage.ts'

export const createLazyLoaderForLanguage = createLanguageLoader(
  { en: 'en-US', de: 'de-DE', es: 'es-ES', fr: 'fr-FR', it: 'it-IT', pt: 'pt-BR' },
  lang => import(`./translations/${lang}.json`),
)
